import React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import * as E360 from '@expert360';
import { NotFoundRoute } from '../NotFoundRoute';

export type Expert = {
  consultant: E360.Maybe<{
    lifecycle: E360.Maybe<{
      accepted?: boolean | null | undefined;
      emailVerified?: boolean | null | undefined;
      privateCloudTalent?: boolean | null | undefined;
      basicProfileCompleted?: boolean | null | undefined;
    }>;
  }>;
};

export type Props = {
  expert: E360.Maybe<Expert>;
} & RouteProps;

const isAcceptedAndVerified = (expert: Expert) => {
  return (
    (expert.consultant?.lifecycle?.accepted ?? false) &&
    (expert.consultant?.lifecycle?.emailVerified ?? false)
  );
};

const isPrivateCloudMember = (expert: Expert) =>
  expert.consultant?.lifecycle?.privateCloudTalent ?? false;

const isBasicProfileCompleted = (expert: Expert) =>
  expert.consultant?.lifecycle?.basicProfileCompleted ?? false;

const isAllowed = (expert: Expert) =>
  (isAcceptedAndVerified(expert) || isPrivateCloudMember(expert)) &&
  isBasicProfileCompleted(expert);

export const ExpertRoute: React.FC<Props> = ({ expert, ...props }) => {
  if (expert && isAllowed(expert)) {
    return <Route {...props} />;
  }

  return <NotFoundRoute {...props} />;
};
